module.exports = __webpack_public_path__ + "img/Icon-Website.e63bb19e.png";